import GradePage from "@/pages/GradePage";
export default function GradeGrade1() {
  return <GradePage grade="1" />;
}
